exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.glyphicon.glyphicon-triangle-top {\r\n    color: #fff;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .action-btn{\r\n    float: none;\r\n    display: block;\r\n    margin: 5px auto;\r\n    text-align: center;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/admins/admins.component.css
// module id = ../../../../../src/app/users/admins/admins.component.css
// module chunks = main